import { Component, OnInit } from '@angular/core';
import { AuthService } from 'epay-library';
import { Observable, of } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'epay-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  username$: Observable<string> = of('');
  usertype$: Observable<string> = of('');
  isLoggedIn$: Observable<boolean> = of(false);
  isSmiPayActive = false;
  routerNavEndSubscription: Subscription;
  private bodyClassObserver: MutationObserver | null = null;

  constructor(private authservice: AuthService, private router: Router) {
    this.routerNavEndSubscription = this.router.events
      .pipe(filter((ev) => ev instanceof NavigationEnd))
      .subscribe(() => {
        this.updateSmiPayActiveState();
      });
  }

  ngOnInit() {
    this.isLoggedIn$ = this.authservice.isLoggedIn;
    this.username$ = this.authservice.currentUserName;
    this.usertype$ = this.authservice.currentUserType;
    this.updateSmiPayActiveState();

    this.bodyClassObserver = new MutationObserver(() => {
      this.updateSmiPayActiveState();
    });

    this.bodyClassObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  private updateSmiPayActiveState(): void {
    const isSmiRoute = this.router.url.includes('/smi-pay-portal');
    const isSmiBodyMode = document.body.classList.contains('smi-immersive-mode');
    this.isSmiPayActive = isSmiRoute || isSmiBodyMode;
  }

  ngOnDestroy() {
    this.routerNavEndSubscription.unsubscribe();
    if (this.bodyClassObserver) {
      this.bodyClassObserver.disconnect();
      this.bodyClassObserver = null;
    }
  }
}
